module.exports = __webpack_public_path__ + "static/img/empty.27fd0ed7.png";